/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import Matter from 'matter-js';
import {gsap} from 'gsap';
import {svgPathProperties} from 'svg-path-properties';
import {decomp} from 'poly-decomp';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        const targetArray = target.split( ', ' );
        $.each( targetArray, function( index, target ) {
          if ( target != 'body' && target != '.navbar' && target != '#scrim-overlay' ) {
            $( target ).slideToggle();
          }
        } );
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }

      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).change( function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload span' );
          $( theInput ).text( filename );
        } );
      }

      const Engine = Matter.Engine;
      const Render = Matter.Render;
      const Runner = Matter.Runner;
      const Bodies = Matter.Bodies;
      const Mouse = Matter.Mouse;
      const Common = Matter.Common;
      const MouseConstraint = Matter.MouseConstraint;
      const Composite = Matter.Composite;
      // Common.setDecomp( require( 'poly-decomp' ) );
      const engine = Engine.create();
      // create a renderer
      const container = document.getElementById( 'footer__gravity-animation' );
      const footerHeight = ( container.offsetHeight + 1 );
      const footerWidth = ( container.offsetWidth + 1 );
      container.style.width = footerWidth;
      container.style.height = footerHeight;


      // container.style.border = '2px solid #141414';
      container.style.position = 'relative';
      const render = Render.create( {
        element: container,
        engine: engine,
        options: {
          width: footerWidth,
          height: footerHeight,
          pixelRatio: 2,
          wireframes: false,
          background: '#141414',
          border: 'none',
        },
      } );

      const borderThickness = 20;
      const borders = [
        // Top border
        Bodies.rectangle( footerWidth / 2, -borderThickness / 2, footerWidth, borderThickness, {isStatic: true} ),
        // Bottom border
        Bodies.rectangle( footerWidth / 2, footerHeight + borderThickness / 2, footerWidth, borderThickness, {isStatic: true} ),
        // Left border
        Bodies.rectangle( -borderThickness / 2, footerHeight / 2, borderThickness, footerHeight, {isStatic: true} ),
        // Right border
        Bodies.rectangle( footerWidth + borderThickness / 2, footerHeight / 2, borderThickness, footerHeight, {isStatic: true} ),
      ];

      // Function to convert SVG path to vertices
      function pathToVertices( pathString, sampleLength = 19 ) {
        const properties = new svgPathProperties( pathString ); // eslint-disable-line new-cap
        const totalLength = properties.getTotalLength();
        const vertices = [];

        for ( let i = 0; i <= totalLength; i += sampleLength ) {
          const point = properties.getPointAtLength( i );
          vertices.push( {x: point.x, y: point.y} );
        }

        return vertices;
      }
      let svgPaths = [];
      if ( window.innerWidth > 768 ) {
        svgPaths = [
          `M81.576 4.18391C48.2222 -7.51564 11.6992 10.0386 -0.000320435 43.3924L120.784 85.7602C132.484 52.4064 114.93 15.8835 81.576 4.18391Z`, // half circle
          `M81.576 4.18391C48.2222 -7.51564 11.6992 10.0386 -0.000320435 43.3924L120.784 85.7602C132.484 52.4064 114.93 15.8835 81.576 4.18391Z`, // half circle
          `M81.576 4.18391C48.2222 -7.51564 11.6992 10.0386 -0.000320435 43.3924L120.784 85.7602C132.484 52.4064 114.93 15.8835 81.576 4.18391Z`, // half circle
          `M122.487 90.5226L90.5234 0L0.000871658 31.9635L122.487 90.5226Z`, // triangle
          `M122.487 90.5226L90.5234 0L0.000871658 31.9635L122.487 90.5226Z`, // triangle
          `M122.487 90.5226L90.5234 0L0.000871658 31.9635L122.487 90.5226Z`, // triangle
          `M69.4204 0.345058L74.0631 24.0334L96.0839 14.145L88.2604 36.9811L112.275 39.4278L94.0818 55.2928L113.656 69.4191L89.9675 74.0618L99.8559 96.0826L77.0198 88.2592L74.5731 112.274L58.7081 94.0805L44.5818 113.655L39.9391 89.9662L17.9183 99.8546L25.7418 77.0185L1.72701 74.5718L19.9204 58.7068L0.346349 44.5805L24.0347 39.9378L14.1463 17.917L36.9824 25.7405L39.4291 1.72572L55.2941 19.9191L69.4204 0.345058Z`, // starburst
          `M69.4204 0.345058L74.0631 24.0334L96.0839 14.145L88.2604 36.9811L112.275 39.4278L94.0818 55.2928L113.656 69.4191L89.9675 74.0618L99.8559 96.0826L77.0198 88.2592L74.5731 112.274L58.7081 94.0805L44.5818 113.655L39.9391 89.9662L17.9183 99.8546L25.7418 77.0185L1.72701 74.5718L19.9204 58.7068L0.346349 44.5805L24.0347 39.9378L14.1463 17.917L36.9824 25.7405L39.4291 1.72572L55.2941 19.9191L69.4204 0.345058Z`, // starburst
          `M69.4204 0.345058L74.0631 24.0334L96.0839 14.145L88.2604 36.9811L112.275 39.4278L94.0818 55.2928L113.656 69.4191L89.9675 74.0618L99.8559 96.0826L77.0198 88.2592L74.5731 112.274L58.7081 94.0805L44.5818 113.655L39.9391 89.9662L17.9183 99.8546L25.7418 77.0185L1.72701 74.5718L19.9204 58.7068L0.346349 44.5805L24.0347 39.9378L14.1463 17.917L36.9824 25.7405L39.4291 1.72572L55.2941 19.9191L69.4204 0.345058Z`, // starburst
        ];
      } else {
        svgPaths = [
          `M40.2689 2.4967C24.2077 -3.13712 6.62039 5.31597 0.986579 21.3772L59.1494 41.779C64.7832 25.7178 56.3301 8.13051 40.2689 2.4967Z`, // half circle
          `M40.2689 2.4967C24.2077 -3.13712 6.62039 5.31597 0.986579 21.3772L59.1494 41.779C64.7832 25.7178 56.3301 8.13051 40.2689 2.4967Z`, // half circle
          `M40.2689 2.4967C24.2077 -3.13712 6.62039 5.31597 0.986579 21.3772L59.1494 41.779C64.7832 25.7178 56.3301 8.13051 40.2689 2.4967Z`, // half circle
          `M0.174425 17.8891L40.209 41.0031L63.3229 0.968492L0.174425 17.8891Z`, // triangle
          `M0.174425 17.8891L40.209 41.0031L63.3229 0.968492L0.174425 17.8891Z`, // triangle
          `M0.174425 17.8891L40.209 41.0031L63.3229 0.968492L0.174425 17.8891Z`, // triangle
          `M28.6794 0.705078L33.3057 11.3687L42.6441 4.44691L41.3188 15.9951L52.8669 14.6698L45.9451 24.0081L56.6087 28.6345L45.9451 33.2608L52.8669 42.5991L41.3188 41.2738L42.6441 52.822L33.3057 45.9002L28.6794 56.5638L24.053 45.9002L14.7147 52.822L16.04 41.2738L4.49183 42.5991L11.4136 33.2608L0.75 28.6345L11.4136 24.0081L4.49183 14.6698L16.04 15.9951L14.7147 4.44691L24.053 11.3687L28.6794 0.705078Z`, // starburst
          `M28.6794 0.705078L33.3057 11.3687L42.6441 4.44691L41.3188 15.9951L52.8669 14.6698L45.9451 24.0081L56.6087 28.6345L45.9451 33.2608L52.8669 42.5991L41.3188 41.2738L42.6441 52.822L33.3057 45.9002L28.6794 56.5638L24.053 45.9002L14.7147 52.822L16.04 41.2738L4.49183 42.5991L11.4136 33.2608L0.75 28.6345L11.4136 24.0081L4.49183 14.6698L16.04 15.9951L14.7147 4.44691L24.053 11.3687L28.6794 0.705078Z`, // starburst
          `M28.6794 0.705078L33.3057 11.3687L42.6441 4.44691L41.3188 15.9951L52.8669 14.6698L45.9451 24.0081L56.6087 28.6345L45.9451 33.2608L52.8669 42.5991L41.3188 41.2738L42.6441 52.822L33.3057 45.9002L28.6794 56.5638L24.053 45.9002L14.7147 52.822L16.04 41.2738L4.49183 42.5991L11.4136 33.2608L0.75 28.6345L11.4136 24.0081L4.49183 14.6698L16.04 15.9951L14.7147 4.44691L24.053 11.3687L28.6794 0.705078Z`, // starburst
        ];
      }


      let currentColor = 0;
      function getCurrentColorIndex() {
        currentColor = currentColor + 1;
        if ( currentColor == 3 ) {
          currentColor = 0;
        }
        return currentColor;
      }
      const shapesColors = [
        '#E4FC82',
        '#35F',
        '#FFF',
      ];

      const svgBodies = svgPaths.map( ( pathString, index ) => {
        const vertices = pathToVertices( pathString, 1 );
        return Bodies.fromVertices(
            Math.floor( Math.random() * footerWidth ),
            0,
            [vertices],
            {
              render: {
                fillStyle: shapesColors[getCurrentColorIndex()],
              },
            },
            true,
        );
      } );

      let shapeSize = 96;
      if ( window.innerWidth < 768 ) {
        shapeSize = 46;
      }
      const shapes = [
        Bodies.rectangle( 70, 0, shapeSize, shapeSize, {
          render: {
            fillStyle: shapesColors[getCurrentColorIndex()],
          },
          density: 0.001,
        } ),
        Bodies.rectangle( ( footerWidth/2 ), 0, shapeSize, shapeSize, {
          render: {
            fillStyle: shapesColors[getCurrentColorIndex()],
          },
          density: 0.001,
        } ),
        Bodies.circle( ( ( footerWidth/2 ) - 200 ), 10, ( shapeSize / 2 ), {
          render: {
            fillStyle: shapesColors[getCurrentColorIndex()],
          },
          density: 0.001,
        } ),
        Bodies.circle( ( ( footerWidth/2 ) - 100 ), 10, ( shapeSize / 2 ), {
          render: {
            fillStyle: shapesColors[getCurrentColorIndex()],
          },
          density: 0.001,
        } ),
        Bodies.circle( ( footerWidth - 100 ), 0, ( shapeSize / 2 ), {
          render: {
            fillStyle: shapesColors[getCurrentColorIndex()],
          },
          density: 0.001,
        } ),
      ];
      const mouse = Mouse.create( render.canvas );
      const mouseConstraint = MouseConstraint.create( engine, {
        mouse: mouse,
        constraint: {
          stiffness: 0.2,
          render: {
            visible: false,
          },
        },
      } );

      Composite.add( engine.world, [...shapes, ...borders, ...svgBodies, mouseConstraint] );
      // keep the mouse in sync with rendering
      render.mouse = mouse;
      // run the renderer
      Render.run( render );

      // create runner
      const runner = Runner.create();

      // run the engine when you scroll to the footer
      $( 'footer' ).each( function() {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            onEnter: ( {progress, direction, isActive} ) => {
              Runner.run( runner, engine );
            },
          },
        } );
      } );

      window.addEventListener( 'resize', () => {
        Render.lookAt( render, {
          min: {x: 0, y: 0},
          max: {x: footerWidth, y: footerHeight},
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
